var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIcoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0C9.57 0 8.3175 0.617984 7.5 1.58692C6.6825 0.617984 5.43 0 4.125 0C1.815 0 0 1.83869 0 4.19618C0 7.07248 2.55 9.42997 6.4125 12.9929L7.5 14L8.5875 12.9929C12.45 9.42997 15 7.07248 15 4.19618C15 1.83869 13.185 0 10.875 0Z",
    fill: "#D63639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcoActive);
export default __webpack_public_path__ + "static/media/fav--ico-active.11411938306cc66a1a6d198d1b90c160.svg";
export { ForwardRef as ReactComponent };